import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootComponent } from './components/root/root.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { AuthGuard as Auth0Guard } from '@auth0/auth0-angular';
import { LayoutComponent } from './components/layout/layout.component';
import { LoggedOutComponent } from './pages/logged-out/logged-out.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { advancedAuthRoutes } from '../../../modules/src/lib/advanced-auth/advanced-auth.routes';
import { FlagEnum } from '../../../modules/src/lib/core/enums/flag.enum';
import {
  GetQuestionnaireComponent,
} from '../../../modules/src/lib/questionnaires/pages/get-questionnaire/get-questionnaire.component';
import {
  Quebec2022TaxFormComponent,
} from '../../../modules/src/lib/questionnaires/components/quebec-2022-tax-questionnaire/quebec-2022-tax-form/quebec-2022-tax-form.component';
import {
  ClientQuestionnaireEditingGuard,
} from '../../../modules/src/lib/questionnaires/guards/client-questionnaire-editing.guard';
import {
  ClientQuestionnaireKeynameEnum,
} from '../../../../../common/src/enums/client-questionnaire/client-questionnaire-keyname.enum';
import { QuestionnaireCompletedComponent } from './pages/questionnaire-completed/questionnaire-completed.component';
import {
  Quebec2023TaxFormComponent,
} from '../../../modules/src/lib/questionnaires/components/quebec-2023-tax-questionnaire/quebec-2023-tax-form/quebec-2023-tax-form.component';

const routes: Routes = [
  {
    path: '',
    component: RootComponent,
    children: [
      {
        path: '',
        component: LayoutComponent,
        canActivate: [Auth0Guard],
        children: [
          {
            path: '',
            component: DashboardComponent,
          },
          {
            path: 'questionnaires',
            children: [
              {
                path: ClientQuestionnaireKeynameEnum.QuebecTaxForm2022,
                data: {
                  flag: FlagEnum.ClientQuestionnairesQuebec2022TaxForm,
                },
                children: [
                  {
                    path: ':questionnaireId',
                    component: GetQuestionnaireComponent,
                    children: [
                      {
                        path: '',
                        component: Quebec2022TaxFormComponent,
                        canDeactivate: [ClientQuestionnaireEditingGuard],
                      },
                      {
                        path: 'completed',
                        component: QuestionnaireCompletedComponent,
                      },
                    ],
                  },
                ],
              }, {
                path: ClientQuestionnaireKeynameEnum.QuebecTaxForm2023,
                data: {
                  flag: FlagEnum.ClientQuestionnairesQuebec2023TaxForm,
                },
                children: [
                  {
                    path: ':questionnaireId',
                    component: GetQuestionnaireComponent,
                    children: [
                      {
                        path: '',
                        component: Quebec2023TaxFormComponent,
                        canDeactivate: [ClientQuestionnaireEditingGuard],
                      },
                      {
                        path: 'completed',
                        component: QuestionnaireCompletedComponent,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'welcome',
        component: WelcomeComponent,
      },
      {
        canActivate: [],
        path: 'logout',
        component: LogoutComponent,
      },
      {
        canActivate: [],
        path: 'not-authorized',
        component: NotAuthorizedComponent,
        pathMatch: 'full',
      },
      {
        canActivate: [],
        path: 'logged-out',
        component: LoggedOutComponent,
        pathMatch: 'full',
      },
      ...advancedAuthRoutes,
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
